import Bowser from 'bowser';

/**
 * Возвращает тип текущего устройства
 * @returns mobile | desktop | tablet
 */
export const getCurrentPlatformType = (): string => {
  const { platform } = Bowser.parse(window.navigator.userAgent);

  return platform.type;
};
